import { motion } from "framer-motion";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { useState } from "react";
import { SignupModal } from "@/components/landing/SignupModal";

const UsoAceptable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header onOpenModal={() => setIsModalOpen(true)} />
      
      <main className="pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4">
              Legal
            </span>
            <h1 className="font-outfit text-4xl sm:text-5xl font-light tracking-tight mb-4">
              Política de Uso Aceptable
            </h1>
            <p className="text-zinc-500 mb-12">Última actualización: Diciembre 2024</p>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Uso Permitido</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  Antropia está diseñado para profesionales de nutrición, coaching deportivo y bienestar. 
                  El uso permitido incluye:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Gestionar consultas nutricionales</li>
                  <li>Seguimiento de mediciones corporales</li>
                  <li>Grabar consultas con consentimiento informado</li>
                  <li>Usar IA para generar resúmenes</li>
                  <li>Almacenar fotos de progreso con consentimiento</li>
                  <li>Compartir progreso mediante vista del cliente</li>
                  <li>Exportar datos propios</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Uso Prohibido</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  Las siguientes actividades están estrictamente prohibidas:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Grabar sin consentimiento informado del cliente</li>
                  <li>Emitir diagnósticos médicos</li>
                  <li>Almacenar datos de menores sin consentimiento parental</li>
                  <li>Presentar contenido de IA como consejo médico certificado</li>
                  <li>Ingeniería inversa de algoritmos de IA</li>
                  <li>Spam o comunicaciones no solicitadas</li>
                  <li>Actividades fraudulentas</li>
                  <li>Revender el servicio sin autorización</li>
                  <li>Compartir credenciales de acceso</li>
                  <li>Scraping o extracción masiva de datos</li>
                  <li>Almacenar material ilegal u obsceno</li>
                  <li>Sobrecargar intencionalmente los servidores</li>
                  <li>Crear múltiples cuentas para evadir límites del plan gratuito</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Datos Sensibles</h2>
                <p className="text-zinc-400 leading-relaxed">
                  El coach es responsable de clasificar y manejar los datos del cliente (biométricos, 
                  de salud) de acuerdo con la legislación aplicable. Esto incluye obtener los 
                  consentimientos necesarios y aplicar las medidas de protección adecuadas.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Reporte de Violaciones</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Si detectas algún uso indebido de la plataforma, repórtalo a{" "}
                  <a href="mailto:abuse@antropia.app" className="text-[#E05D3A] hover:underline">abuse@antropia.app</a>. 
                  Las investigaciones se realizan dentro de 48 horas hábiles.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Consecuencias</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Primera infracción:</strong> Advertencia por escrito.</p>
                  <p><strong className="text-white">Segunda infracción:</strong> Suspensión temporal de la cuenta.</p>
                  <p><strong className="text-white">Infracciones graves o repetidas:</strong> Terminación permanente de la cuenta.</p>
                  <p>Antropia puede reportar actividades ilegales a las autoridades competentes.</p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
      <SignupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default UsoAceptable;
